<template>
  <v-row>
    <v-col>
      <v-card>
        <v-alert
          dense
          colored-border
          color="success"
          :border="contactLensTest.adapted ? 'left' : null"
        >
          <v-container fluid>
            <v-row dense align="center" v-if="this.contactLensTest.adapted">
              <v-col>
                <v-row dense>
                  <v-col> {{ contactLensTest.lens.group.name }} </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col>
                    {{ contactLensTest.lens.group.manufacturer.name }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col> {{ contactLensTest.lens.group.layout.name }} </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col> {{ contactLensTest.material.name }} </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider v-if="this.contactLensTest.adapted" />

            <v-row dense align="center">
              <v-col>
                <v-row dense>
                  <v-col>
                    {{ contactLensTest.eye }}
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-tooltip top v-if="contactLensTest.createdAt">
                    <template v-slot:activator="{ on, attrs }">
                      <v-col cols="auto" v-bind="attrs" v-on="on">
                        <v-icon small>eva-clock-outline</v-icon>

                        {{
                          $moment(
                            contactLensTest.createdAt,
                            "YYYY-MM-DD HH:mm:ss ZZ"
                          ) | moment("HH:mm")
                        }}
                      </v-col>
                    </template>

                    <span>Horário do teste de lente de contato</span>
                  </v-tooltip>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="text-body-2 font-weight-bold"> Dioptria </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ contactLensTest.diopter }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="text-body-2 font-weight-bold"> Raio </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ contactLensTest.radius }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="text-body-2 font-weight-bold">
                    Grau Esférico
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ contactLensTest.finalSpherical }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="text-body-2 font-weight-bold"> Diâmetro </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ contactLensTest.diameter }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="text-body-2 font-weight-bold"> Cilíndro </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ contactLensTest.finalCylindrical }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="text-body-2 font-weight-bold"> Eixo </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ contactLensTest.finalAxis }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="auto">
                <v-row dense>
                  <v-col class="text-body-2 font-weight-bold">
                    Acuidade visual
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ contactLensTest.finalVisualAcuity }}
                  </v-col>
                </v-row>
              </v-col>

              <v-spacer />

              <v-col cols="auto">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="toggleAdapted"
                      :disabled="!allowEdit"
                    >
                      <v-icon
                        :color="contactLensTest.adapted ? 'success' : 'gray'"
                      >
                        ri-check-double-line
                      </v-icon>
                    </v-btn>
                  </template>

                  <span>
                    <span v-if="contactLensTest.adapted">Adaptada</span>
                    <span v-else>Não adaptada</span>
                  </span>
                </v-tooltip>

                <authorization
                  v-if="allowEdit"
                  permissionKey="attendance_contact_lens_test"
                  can="save"
                  v-slot:default="{ authorization }"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        :to="`lentes-contato/${contactLensTest.id}`"
                        v-if="authorization"
                      >
                        <v-icon>eva-edit-outline</v-icon>
                      </v-btn>
                    </template>

                    <span> Editar </span>
                  </v-tooltip>
                </authorization>

                <authorization
                  v-if="allowDelete"
                  permissionKey="attendance_contact_lens_test"
                  can="delete"
                  v-slot:default="{ authorization }"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        @click="deleteExam"
                        v-if="authorization"
                      >
                        <v-icon>eva-trash-outline</v-icon>
                      </v-btn>
                    </template>

                    <span> Excluir </span>
                  </v-tooltip>
                </authorization>
              </v-col>
            </v-row>

            <v-row v-if="this.contactLensTest.adapted">
              <v-col> Notas: {{ contactLensTest.notes }} </v-col>
            </v-row>
          </v-container>
        </v-alert>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ContactLensTestListItem",
  props: {
    attendance: Object,
    contactLensTest: Object,
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    refreshList: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    deleteExam() {
      if (!this.allowDelete) return;
      if (
        confirm("Você realmente deseja deletar esse teste de Lente de contato?")
      ) {
        this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/delete_contact_lens_test.gql"),
          variables: {
            contactLensTestId: this.contactLensTest.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Teste de Lente de contato deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    toggleAdapted() {
      if (!this.allowEdit) return;

      let materialId = this.lodash.get(this.contactLensTest.material, "id", "");

      return this.apolloMutate({
        mutation: require("@/graphql/contact_lens_test/save_contact_lens_test.gql"),
        variables: {
          attendanceId: this.attendance.id,
          contactLensTestId: this.contactLensTest.id,
          contactLensTestMaterialId: materialId,
          contactLensTestLensId: this.contactLensTest.lens.id,
          eye: this.contactLensTest.eye,
          diopter: this.contactLensTest.diopter,
          radius: this.contactLensTest.radius,
          diameter: this.contactLensTest.diameter,
          contactLensObservation: this.contactLensTest.contactLensObservation,
          contactLensSpherical: this.contactLensTest.contactLensSpherical,
          contactLensCylindrical: this.contactLensTest.contactLensCylindrical,
          contactLensAxis: this.contactLensTest.contactLensAxis,
          contactLensVisualAcuity: this.contactLensTest.contactLensVisualAcuity,
          refractedSpherical: this.contactLensTest.refractedSpherical,
          refractedCylindrical: this.contactLensTest.refractedCylindrical,
          refractedAxis: this.contactLensTest.refractedAxis,
          refractedVisualAcuity: this.contactLensTest.refractedVisualAcuity,
          finalSpherical: this.contactLensTest.finalSpherical,
          finalCylindrical: this.contactLensTest.finalCylindrical,
          finalAxis: this.contactLensTest.finalAxis,
          finalVisualAcuity: this.contactLensTest.finalVisualAcuity,
          notes: this.contactLensTest.notes,
          adapted: !this.contactLensTest.adapted,
        },
      }).then(({ data }) => {
        this.refreshList();

        return data.saveExam;
      });
    },
  },
}
</script>

<style lang="scss" scoped></style>
